import React, { useState, useEffect } from "react";
import { Badge, Drawer, Card, Button } from "antd";
import { BellOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { ExpenseServices } from "../../Services/Manage/ExpenseServices";
import { NotificationService } from "../../Services/Manage/NotificationService";

const QuickMessage = () => {
  const [open, setOpen] = useState(false);
const [recentExpenses, setRecentExpenses] = useState([]);
  const [leaveNotifications, setLeaveNotifications] = useState([]);
  const [hiddenNotifications, setHiddenNotifications] = useState([]);
  const [targetNotifications, setTargetNotifications] = useState([]);
  const [hiddenTargetIds, setHiddenTargetIds] = useState([]);
  const navigate = useNavigate();

const fetchTargetNotifications = async () => {
    try {
      const omeUser = JSON.parse(localStorage.getItem("ome_user") || "{}");
      const uid = omeUser?.uid || omeUser?.user_id || "";
      const name = omeUser?.name || omeUser?.user_name || "";
      const res = await NotificationService.getForUser(uid, name);
      if (res.status && Array.isArray(res.data)) {
        setTargetNotifications(res.data.map((n) => ({ ...n, createdAt: n.created_at })));
      } else {
        setTargetNotifications([]);
      }
    } catch (e) {
      console.error("fetch notifications error:", e);
      setTargetNotifications([]);
    }
  };

const fetchLeaveNotifications = () => {
    try {
      const raw = localStorage.getItem("ome_permission");
      const parsed = JSON.parse(raw);
      const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
      const perm = permissions.find(p => p.link === '/workforce-management');
      const hasAccess = perm && (perm.read || perm.add || perm.edit || perm.delete);
      if (!hasAccess) {
        setLeaveNotifications([]);
        return;
      }
    } catch { 
      setLeaveNotifications([]);
      return;
    }
    const data = JSON.parse(localStorage.getItem("leave_notifications") || "[]");
    setLeaveNotifications(data);
  };

  const fetchRecentExpenses = async () => {
    try {
      const res = await ExpenseServices.getRecentExpenses();
      if (res.status && res.data && res.data.length > 0) {
        setRecentExpenses(res.data);
      } else {
        setRecentExpenses([]);
      }
    } catch (error) {
      console.error("Error fetching recent expenses:", error);
      setRecentExpenses([]);
    }
  };

useEffect(() => {
    fetchRecentExpenses();
    fetchLeaveNotifications();
    fetchTargetNotifications();

    const handleLeaveNotification = () => fetchLeaveNotifications();
    window.addEventListener("leave_notification_created", handleLeaveNotification);

    const interval = setInterval(fetchTargetNotifications, 60000);

    return () => {
      window.removeEventListener("leave_notification_created", handleLeaveNotification);
      clearInterval(interval);
    };
  }, []);

const handleBellClick = async () => {
    setOpen(true);
    await fetchRecentExpenses();
    fetchLeaveNotifications();
    fetchTargetNotifications();
  };

  const handleCloseExpenseNotification = (id) => {
    setRecentExpenses((prev) => prev.filter((item) => item.id !== id));
  };

  const handleCloseLeaveNotification = (id) => {
  setHiddenNotifications((prev) => [...prev, id]);
};

 const handleReviewLeave = (id) => {
  const updated = leaveNotifications.filter(
    (item) => item.id !== id
  );

  setLeaveNotifications(updated);
  localStorage.setItem(
    "leave_notifications",
    JSON.stringify(updated)
  );

  setOpen(false);
  navigate("/workforce-management");
};
    //notification symbol number 
  const visibleLeaveCount = leaveNotifications.filter(
  (leave) => !hiddenNotifications.includes(leave.id)
).length;

const visibleTargetCount = targetNotifications.filter(n => !hiddenTargetIds.includes(n.id)).length;
  const totalCount = recentExpenses.length + visibleLeaveCount + visibleTargetCount;

  return (
    <>
      <Badge count={totalCount} offset={[5, 0]}>
        <BellOutlined
          style={{ fontSize: 22, cursor: "pointer", color: "#3b94e2ff" }}
          onClick={handleBellClick}
        />
      </Badge>

      <Drawer
        title={<b>Notifications</b>}
        placement="right"
        open={open}
        onClose={() => setOpen(false)}
        width={380}
        closable={true}
        bodyStyle={{
          padding: "12px",
          overflowY: "auto",
          height: "100%",
        }}
      >
        {leaveNotifications
        .filter((leave) => !hiddenNotifications.includes(leave.id))
        .map((leave) => (
            <Card
              key={leave.id}
              size="small"
              style={{
                borderRadius: 10,
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                marginBottom: 12,
                border: "1px solid #e5e7eb",
                position: "relative",
              }}
            >
              <CloseOutlined
                onClick={() => handleCloseLeaveNotification(leave.id)}
                style={{
                  position: "absolute",
                  top: 8,
                  right: 10,
                  fontSize: 14,
                  color: "#999",
                  cursor: "pointer",
                }}
              />

              <div style={{ paddingRight: 20 }}>
                <div style={{ fontWeight: "bold", fontSize: 15 }}>
                  Leave Request
                </div>

                <div style={{ fontSize: 13, color: "#555", marginTop: 6 }}>
                  {leave.employeeName} ({leave.employeeId}) requested{" "}
                  {leave.leaveType} from{" "}
                  {dayjs(leave.fromDate).format("DD-MMM-YYYY")} to{" "}
                  {dayjs(leave.toDate).format("DD-MMM-YYYY")} (
                  {leave.totalDays} days).
                </div>

                <Button
                  type="link"
                  style={{ padding: 0, marginTop: 6 }}
                  onClick={() => handleReviewLeave(leave.id)}
                >
                  Click to review
                </Button>
              </div>
            </Card>
          ))}

 {targetNotifications
          .filter(n => !hiddenTargetIds.includes(n.id))
          .map(n => (
            <Card
              key={n.id}
              size="small"
              style={{
                borderRadius: 10, backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                marginBottom: 12, border: "1px solid #e5e7eb",
                position: "relative",
              }}
            >
              <CloseOutlined
                onClick={() => setHiddenTargetIds(prev => [...prev, n.id])}
                style={{ position: "absolute", top: 8, right: 10, fontSize: 14, color: "#999", cursor: "pointer" }}
              />
              <div style={{ paddingRight: 20 }}>
                <div style={{ fontWeight: "bold", fontSize: 15, color: "#1677ff" }}>{n.title}</div>
          <div style={{ fontSize: 13, color: "#555", marginTop: 6 }}>{n.message}</div>
                {n.reminder && (
                  <div style={{ fontSize: 12, color: "#fa8c16", marginTop: 4, fontWeight: 600 }}>
                    ⏰ Reminder: {n.reminder}
                  </div>
                )}
                <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>
                  {dayjs(n.createdAt).format("DD-MMM-YYYY hh:mm A")}
                </div>
  <Button
                  type="link"
                  style={{ padding: 0, marginTop: 4 }}
                  onClick={async () => {
                    try { await NotificationService.markRead(n.id); } catch {}
                    setHiddenTargetIds(prev => [...prev, n.id]);
                    setOpen(false);
                    navigate(n.link || "/sales-target");
                  }}
                >
                  View Targets
                </Button>
              </div>
            </Card>
          ))}

        {recentExpenses.length > 0 &&
          recentExpenses.map((expense) => (
            <Card
              key={expense.id}
              size="small"
              style={{
                borderRadius: 10,
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                marginBottom: 12,
                border: "1px solid #e5e7eb",
                position: "relative",
              }}
            >
              <CloseOutlined
                onClick={() => handleCloseExpenseNotification(expense.id)}
                style={{
                  position: "absolute",
                  top: 8,
                  right: 10,
                  fontSize: 14,
                  color: "#999",
                  cursor: "pointer",
                }}
              />

              <div style={{ paddingRight: 20 }}>
                <div style={{ fontWeight: "bold", fontSize: 15 }}>
                  Subscription Due | {expense.description || "New Expense"}
                </div>
                <div style={{ fontSize: 13, color: "#555" }}>
                  Subscription Date: {expense.expense_date}
                </div>  
                <div style={{ fontSize: 13, color: "#555" }}>
                  Type: {expense.subscription_type || "N/A"}
                </div>
              </div>
            </Card>
          ))}

   {visibleLeaveCount === 0 && recentExpenses.length === 0 && visibleTargetCount === 0 && (
          <p style={{ textAlign: "center", color: "#888", marginTop: 20 }}>
            No notifications.
          </p>
        )}
      </Drawer>
    </>
  );
};

export default QuickMessage;